export const Icons = {
    Fuel: "semantic-fuel",
    FuelPetrol: "semantic-petrol",
    FuelDiesel: "semantic-diesel",
    FuelElectric: "semantic-electric",
    FuelHybrid: "semantic-hybrid",
    FuelNaturalGas: "semantic-fuel-natural-gas",

    Transmission: 'semantic-transmission-manual',
    TransmissionManual: 'semantic-transmission-manual',
    TransmissionAutomatic: 'semantic-transmission-automatic',
};
